import { createSlice } from '@reduxjs/toolkit';
import { productVariationEdit } from './productAsyncThunk';

const productVariationEditSlice = createSlice({
  name: "product",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productVariationEdit.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productVariationEdit.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productVariationEdit.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productVariationEditSlice.reducer;